import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../shared/services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
  ) {}
  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.checkUserLogin(next, state.url);
  }

  async checkUserLogin(route: ActivatedRouteSnapshot, returnUrl: string) {
    const isLoggedIn = await this.authService.usuarioLogado();
    const perfil = localStorage.getItem('perfil') || sessionStorage.getItem('perfil');
    const senhaProvisoria = localStorage.getItem('senhaProvisoria');
    if (!isLoggedIn) {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
      return false;
    }
    if (route.data['role'].indexOf(perfil) === -1) {
      this.toastr.warning('Área sem permissão', 'Atenção');
      this.router.navigate(['/auth/login']);
      return false;
    }
    if(senhaProvisoria){
      this.toastr.warning('Usuário com senha provisória', 'Atenção');
      this.router.navigate(['/extra/senha-provisoria']);
      return false;
    }
    return true;
  }
}
